import { Button, Popover, PopoverContent, PopoverTrigger } from '@shigo-ui/ui';
import { Info } from 'lucide-react';

import {
  formatList,
  itemLabel,
  nestedName,
  stringValue,
  type UnknownItem,
} from './SelectedSupplyTables.helpers';
import { dashboardT } from '../../../../lib/messages';

export function AppInfoPopover({ app }: { app: UnknownItem }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="text-primary h-8 w-8"
          aria-label={dashboardT('targeting.showDetailsFor', { name: itemLabel(app) })}
        >
          <Info className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="max-h-96 w-96 overflow-auto p-0">
        <dl className="divide-border divide-y text-sm">
          <InfoRow label={dashboardT('madBuy.common.name')} value={itemLabel(app)} />
          <InfoRow
            label={dashboardT('targeting.publishers')}
            value={stringValue(app['publishers'])}
          />
          <InfoRow
            label={dashboardT('madBuy.supply.apps.appStoreId')}
            value={stringValue(app['appStoreId'])}
          />
          <InfoRow
            label={dashboardT('madBuy.supply.apps.bundleId')}
            value={stringValue(app['bundleId'])}
          />
          <InfoRow
            label={dashboardT('madBuy.supply.apps.platform')}
            value={nestedName(app['platform'])}
          />
          <InfoRow
            label={dashboardT('madBuy.common.url')}
            value={stringValue(app['appStoreUrl'])}
          />
          <InfoRow
            label={dashboardT('madBuy.supply.apps.iabCategories')}
            value={formatList(app['iabCategoryNames'] ?? app['iabCategories'])}
          />
        </dl>
      </PopoverContent>
    </Popover>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="grid grid-cols-[120px_1fr] gap-3 px-4 py-3">
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="text-foreground break-words">{value || '-'}</dd>
    </div>
  );
}
